// goldfish/static/js/main.js
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import * as bootstrap from 'bootstrap';

import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css';

import $ from 'jquery';
import 'datatables.net';
import DataTable from 'datatables.net-bs5';
// import 'datatables.net-bs5';
import 'datatables.net-buttons';
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';

import '@fortawesome/fontawesome-free/css/all.min.css';
import JSZip from 'jszip';  // Make sure to import JSZip

// Import ReconnectingWebSocket
import { ReconnectingWebSocket } from './reconnecting-websocket';

// Make jQuery available globally
window.$ = window.jQuery = $;
// Make bootstrap available globally
window.bootstrap = bootstrap;
// Make JSZip globally available
window.JSZip = JSZip;
// Make DataTable available globally
window.DataTable = DataTable;
// Make ReconnectingWebSocket available globally
window.ReconnectingWebSocket = ReconnectingWebSocket;

// Add this to your main.js file
document.addEventListener('DOMContentLoaded', () => {
  // Initialize all dropdowns
  document.querySelectorAll('.dropdown-toggle').forEach(dropdownToggle => {
    dropdownToggle.addEventListener('click', function(e) {
      e.preventDefault();
      const dropdownMenu = this.nextElementSibling;
      if (dropdownMenu.classList.contains('show')) {
        dropdownMenu.classList.remove('show');
        this.setAttribute('aria-expanded', 'false');
      } else {
        dropdownMenu.classList.add('show');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });
});